/**
 * Digit count for the live counters in a summary stats row (Compatibility,
 * Loudness, Organize).
 *
 * Every counter in a row is bounded by the run's total, so reserving the
 * TOTAL's digit count for every number (as the `--stat-digits` CSS variable,
 * consumed by `.stat-number` / `.stat-count` in App.scss) keeps the label
 * beside a number and every item after it from shifting as the count climbs
 * ("1" → "22" → "150"). Pass the total plus every counter; the widest wins,
 * so a row whose total is only learned at the end (Organize) still only
 * re-flows at a digit boundary (9 → 10) instead of on every tick.
 */
export function statDigits(...values) {
    let max = 0;
    for (const v of values) {
        const n = Math.abs(Number(v));
        if (Number.isFinite(n) && n > max) max = n;
    }
    return String(Math.floor(max)).length;
}
